import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@repo/share-log-web-utils";

const inputVariants = cva(
  "flex w-full rounded-md border bg-background px-3 py-2 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "border-input",
        error: "border-destructive focus-visible:ring-destructive",
      },
      inputSize: {
        default: "h-10",
        sm: "h-8 text-xs",
        lg: "h-12 text-base",
      },
    },
    defaultVariants: {
      variant: "default",
      inputSize: "default",
    },
  },
);

export interface InputProps
  extends Omit<React.ComponentProps<"input">, "size">,
    VariantProps<typeof inputVariants> {}

function Input({
  className,
  variant,
  inputSize,
  type,
  ...props
}: InputProps) {
  return (
    <input
      type={type}
      className={cn(inputVariants({ variant, inputSize, className }))}
      data-slot="input"
      {...props}
    />
  );
}

export { Input, inputVariants };
